


export function checkIsMobile() {
  return document.documentElement.clientWidth < 1024
}

export function trackEvent(eventName, params = {}) {
  // const isMobile = checkIsMobile()
  // const trackingPrefix = isMobile ? 'pc_' : 'mobile_' 

  gtag('event', eventName, params)
}
